import React from "react";
import Zendesk from "react-zendesk";

import {getUser} from '../../utils/TokenManager';


const ZENDESK_KEY = "416893db-26fb-4d32-8611-e67b23425882";
 
 
const ZendeskSupport = () => {
    const user = getUser();
    const userName = user ? user.full_name : "";
    const userEmail = user ? user.email : "";
    const setting = {
        color: {
            theme: "#301935"
        },
        launcher: {
            chatLabel: {
                "en-US": "Need Help"
            }
        },
        contactForm: {
            fields: [
                {id: "name", prefill: {"*": userName}},
                {id: "email", prefill: {"*": userEmail}}
            ]
        }
    };

    return (
        <Zendesk 
            zendeskKey={ZENDESK_KEY} 
            {...setting} 
            onLoaded={() => console.log('is loaded')} 
        />
    );
};

export default ZendeskSupport;



// WEBPACK FOOTER //
// ./src/components/common/Zendesk.js